export const firebase_cred = {
  production: true,
  firebase: {
      dev: {
          apiKey: "AIzaSyAf-iktzfSdkAIMGnCuHDgGrwil7wb6BOU",
          authDomain: "vfa-ocr.firebaseapp.com",
          databaseURL: "https://vfa-ocr.firebaseio.com",
          projectId: "vfa-ocr",
          storageBucket: "vfa-ocr.appspot.com",
          messagingSenderId: "440064262726",
          appId: "1:440064262726:web:ceab454ae34063e0",
      },
      prod: {
          apiKey: "AIzaSyCDlirAoLN9LD8IqGWFeXF8JTtKNXZLb-k",
          authDomain: "vfa-ocr-prod.firebaseapp.com",
          databaseURL: "https://vfa-ocr-prod.firebaseio.com",
          projectId: "vfa-ocr-prod",
          storageBucket: "vfa-ocr-prod.appspot.com",
          messagingSenderId: "104482542803",
          appId: "1:104482542803:web:3ecb51b12b8485ecf63026",
          measurementId: "G-Z0HWTJLJV3"
      }

  }
};
